import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["menu", "openIcon", "closeIcon"];

  connect() {
    this.closeHandler = this.close.bind(this);
    document.addEventListener("turbo:before-visit", this.closeHandler);
    document.addEventListener("turbo:submit-start", this.closeHandler);
  }

  disconnect() {
    document.removeEventListener("turbo:before-visit", this.closeHandler);
    document.removeEventListener("turbo:submit-start", this.closeHandler);
  }

  toggle() {
    const isHidden = this.menuTarget.classList.toggle("hidden");
    this.openIconTarget.classList.toggle("hidden", !isHidden);
    this.closeIconTarget.classList.toggle("hidden", isHidden);
  }

  close() {
    this.menuTarget.classList.add("hidden");
    this.openIconTarget.classList.remove("hidden");
    this.closeIconTarget.classList.add("hidden");
  }
}
